'use strict';

/*@ngInject*/
module.exports = function ($timeout) {
    return {
        scope: { trigger: '@focusModal' },
        link: function link(scope, element) {
            var modal = element[0];
            var modalButton = modal.querySelector('#first-input'); // replace with the class or ID of the first input in the modal

            scope.$watch('trigger', function (value) {
                if (value === 'true') {
                    $timeout(function () {
                        modalButton.focus();
                    });
                }
            });

            function redirectFocus(event) {
                event.preventDefault();
            }

            function checkModalFocus(event) {
                if (!modal.contains(document.activeElement)) {
                    event.preventDefault();
                    modalButton.focus();
                }
            }

            function handleKeydown(event) {
                if (event.keyCode === 9) {
                    // tab key
                    var focusableElements = modal.querySelectorAll('button, a,[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                    var firstFocusable = focusableElements[0];
                    var lastFocusable = focusableElements[focusableElements.length - 1];
                    if (event.shiftKey) {
                        if (document.activeElement === firstFocusable || document.activeElement === modalButton) {
                            event.preventDefault();
                            lastFocusable.focus();
                        } else if (!modal.contains(document.activeElement)) {
                            event.preventDefault();
                            modalButton.focus();
                        }
                    } else {
                        if (document.activeElement === lastFocusable && modal.contains(document.activeElement)) {
                            event.preventDefault();
                            modalButton.focus();
                        } else if (!modal.contains(document.activeElement)) {
                            event.preventDefault();
                            firstFocusable.focus();
                        }
                    }
                }
            }

            modal.addEventListener('mousedown', redirectFocus);
            modal.addEventListener('keydown', handleKeydown);

            document.addEventListener('focus', checkModalFocus, true);

            scope.$on('$destroy', function () {
                modal.removeEventListener('mousedown', redirectFocus);
                modal.removeEventListener('keydown', handleKeydown);
                document.removeEventListener('focus', checkModalFocus, true);
            });
        }
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/modal/focus-modal.directive.js
 **/